import { useEffect, type ReactNode } from 'react'

import type { ThemeName } from '@/features/settings/schemas/theme'
import { useUiStore } from '@/features/settings/stores/ui-store'

function applyTheme(theme: ThemeName): void {
  const root = document.documentElement
  root.classList.toggle('dark', theme === 'dark')
  root.dataset.theme = theme
}

export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useUiStore((state) => state.theme)

  useEffect(() => {
    applyTheme(theme)
  }, [theme])

  return children
}

export function useTheme() {
  const theme = useUiStore((state) => state.theme)
  const setTheme = useUiStore((state) => state.setTheme)
  const toggleTheme = useUiStore((state) => state.toggleTheme)

  return { theme, setTheme, toggleTheme }
}
